import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from "axios";
import moment from "moment";
import { getUserToken, isMobileApp } from "../utils";
var request = axios.create({});
export function useSubmitTime() { return { submitTime: moment().toISOString() }; }
export function updateSessionTime() { return _updateSessionTime.apply(this, arguments); }
function _updateSessionTime() { _updateSessionTime = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() { var store, updateSessionTimeAction; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            _context.next = 2;
            return import("../../store/store");
        case 2:
            store = _context.sent.default;
            _context.next = 5;
            return import("../../store/qnbSlice");
        case 5:
            updateSessionTimeAction = _context.sent.updateSessionTime;
            store.dispatch(updateSessionTimeAction());
        case 7:
        case "end": return _context.stop();
    }
} }, _callee); })); return _updateSessionTime.apply(this, arguments); }
request.interceptors.request.use(function (req) {
    var _req$data, _req$data2, _req$data5;
    if (!req.headers["Accept-Language"]) {
        req.headers["Accept-Language"] = "zh-HK,zh-CN,en-US";
    } // zh-HK,zh-CN,en-US
    var languageMapping = { en: "en-US", hk: "zh-HK", cn: "zh-CN" };
    var url = window.location.href.split("/");
    var lang = Object.keys(languageMapping).filter(function (key) { return url.includes(key); });
    var locale = "en-US";
    if (lang.length > 0) {
        locale = languageMapping[lang[0]];
        req.headers["Accept-Language"] = locale;
    }
    if ((_req$data = req.data) !== null && _req$data !== void 0 && _req$data.useSubmitTime) {
        req.data = Object.assign({}, req.data, { isMobileApp: isMobileApp(), useSubmitTime: undefined }, useSubmitTime());
    }
    if (((_req$data2 = req.data) === null || _req$data2 === void 0 ? void 0 : _req$data2.inlineError) != null) {
        var _req$data3;
        if (((_req$data3 = req.data) === null || _req$data3 === void 0 ? void 0 : _req$data3.inlineError) === true) {
            var _req$data4;
            req.headers["X-Inline-Error"] = ((_req$data4 = req.data) === null || _req$data4 === void 0 ? void 0 : _req$data4.inlineError) === true;
        }
        req.data = Object.assign({}, req.data, { inlineError: undefined });
    }
    if ((_req$data5 = req.data) !== null && _req$data5 !== void 0 && _req$data5.quoteNo) {
        var _req$data6;
        req.data = Object.assign({}, req.data, { userToken: getUserToken((_req$data6 = req.data) === null || _req$data6 === void 0 ? void 0 : _req$data6.quoteNo) });
    }
    return req;
});
request.interceptors.response.use(function (res) { var _res$data; updateSessionTime(); if (!((_res$data = res.data) !== null && _res$data !== void 0 && _res$data.result)) {
    return getErrorResult(res.config, function (inline) { return handleError({ response: res }, inline); });
} return res; }, function (err) { return getErrorResult(err.config, function (inline) { return handleError(err === null || err === void 0 ? void 0 : err.response, inline); }); });
function checkInlineError(config) { var _ref, _config$requestHeader; return !!((_ref = (_config$requestHeader = config === null || config === void 0 ? void 0 : config.requestHeaders) !== null && _config$requestHeader !== void 0 ? _config$requestHeader : config === null || config === void 0 ? void 0 : config.headers) !== null && _ref !== void 0 && _ref["X-Inline-Error"]); } /** With X-Inline-Error: promo quote errors reject the promise for inline handling. */
var PROMO_INLINE_ONLY_ERROR_CODES = new Set(["-404", "-408", "-413", "-415", "-026", "-417", "-418", "-420"]);
function getErrorResult(_x, _x2) { return _getErrorResult.apply(this, arguments); }
function _getErrorResult() { _getErrorResult = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(req, res) { var _resp$data$errorCode; var isInline, resp; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
    switch (_context2.prev = _context2.next) {
        case 0:
            isInline = checkInlineError(req);
            _context2.next = 3;
            return res(isInline);
        case 3:
            resp = _context2.sent;
            if (!(isInline && !PROMO_INLINE_ONLY_ERROR_CODES.has((_resp$data$errorCode = resp.data.errorCode) !== null && _resp$data$errorCode !== void 0 ? _resp$data$errorCode : ""))) {
                _context2.next = 6;
                break;
            }
            return _context2.abrupt("return", resp);
        case 6:
            _context2.t0 = Promise;
            _context2.next = 9;
            return resp;
        case 9:
            _context2.t1 = _context2.sent;
            return _context2.abrupt("return", _context2.t0.reject.call(_context2.t0, _context2.t1));
        case 11:
        case "end": return _context2.stop();
    }
} }, _callee2); })); return _getErrorResult.apply(this, arguments); }
function handleError(_x3, _x4) { return _handleError.apply(this, arguments); }
function _handleError() { _handleError = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(err, inline) { var _err$response, _resp$data2; var store, resp, _resp$data, errorCode, silentErrorCodes, isGeneralSilent; return _regeneratorRuntime.wrap(function _callee3$(_context3) { while (1) {
    switch (_context3.prev = _context3.next) {
        case 0:
            _context3.next = 2;
            return import("../../store/store");
        case 2:
            store = _context3.sent.default;
            resp = (_err$response = err === null || err === void 0 ? void 0 : err.response) !== null && _err$response !== void 0 ? _err$response : err;
            if (!inline) {
                errorCode = resp === null || resp === void 0 ? void 0 : (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.errorCode;
                silentErrorCodes = new Set(["WC-001", "WC-002", "WC-003", "WC-004", "WC-005"]);
                isGeneralSilent = silentErrorCodes.has(errorCode !== null && errorCode !== void 0 ? errorCode : "");
                if (!isGeneralSilent) {
                    store.dispatch({ type: "ui/setAlertDialog", payload: errorCode !== null && errorCode !== void 0 ? errorCode : "-001" });
                }
            }
            store.dispatch({ type: "ui/setErrorData", payload: resp === null || resp === void 0 ? void 0 : (_resp$data2 = resp.data) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.data });
            return _context3.abrupt("return", resp);
        case 7:
        case "end": return _context3.stop();
    }
} }, _callee3); })); return _handleError.apply(this, arguments); }
export default request;
